import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface IsCandidateAttachedToCaseResponse extends BackendResponse {
  item: number;
}
export interface IsCandidateAttachedToCaseParameters extends NextApiParams {
  typeRelated: number | null;
  idRelated: number | null;
}

export const isCandidateAttachedToCase = withNextApi<
  IsCandidateAttachedToCaseResponse,
  IsCandidateAttachedToCaseParameters
>("/cvp/CvpIsCandidateAttachedToCase");
